/*!

=========================================================
* WOO Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.tony-woo.com/product/woo-dashboard-pro-react
* Copyright 2020 Tony Woo (https://www.tony-woo.com)

* Coded by Tony Woo

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
// nodejs library that concatenates classes
import classnames from 'classnames';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
// reactstrap components
import { Collapse, Navbar, NavItem, NavLink, Nav, Container } from 'reactstrap';

import Profile from './Profile';
import { SearchForm } from './SearchForm';
import NotificationAlert from 'react-notification-alert';
import { notificationAlert } from 'variables/common';
import { connect } from 'react-redux';
import { Affix } from 'antd';
import { colors } from '../../constants/index';
// import styles from './styles.module.css'
import BookActivationComponent from 'modules/ClassModule/components/BookActivationComponent';

class AdminNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userInfo: this.props.loggedInUser,
      modalVisible: false,
    };
  }

  activeBook = () => {
    this.setState({ modalVisible: !this.state.modalVisible });
  };
  setModalVisible = () => {
    this.setState({ modalVisible: !this.state.modalVisible });
  };

  render() {
    // const { userInfo } = this.state;
    // if (!userInfo) {
    //   this.props.history.push('/');
    // }
    return (
      <>
        <Affix>
          <div>
            <div className='rna-wrapper'>
              <NotificationAlert ref={notificationAlert} />
            </div>
            <Navbar
              style={{ background: '#11CCEE' }}
              className={classnames(
                'navbar-top navbar-expand border-bottom',
                // "navbar-top navbar-expand border-bottom bg-white",
                { 'navbar-dark bg-info': this.props.theme === 'dark' },
                { 'navbar-light bg-secondary': this.props.theme === 'light' },
              )}
            >
              <Container fluid>
                <Collapse navbar isOpen={true}>
                  {/* SEARCh FORM */}
                  {/* <SearchForm theme={this.props.theme} /> */}
                  <div style={{ height: 100 }} />

                  <Nav className='align-items-center ml-md-auto' navbar>
                    <NavItem className='d-xl-none'>
                      <div className={classnames('pr-3 sidenav-toggler', { active: this.props.sidenavOpen }, { 'sidenav-toggler-dark': this.props.theme === 'dark' })} onClick={this.props.toggleSidenav}>
                        <i className='fas fa-bars'></i>
                        {/* <div className="sidenav-toggler-inner">
                        <i className="sidenav-toggler-line" />
                        <i className="sidenav-toggler-line" />
                        <i className="sidenav-toggler-line" />
                      </div> */}
                      </div>
                    </NavItem>

                    <NavItem className='d-sm-none'>
                      <NavLink
                        onClick={() => {
                          document.body.classList.add('g-navbar-search-showing');
                          setTimeout(function () {
                            document.body.classList.remove('g-navbar-search-showing');
                            document.body.classList.add('g-navbar-search-show');
                          }, 150);
                          setTimeout(function () {
                            document.body.classList.add('g-navbar-search-shown');
                          }, 300);
                        }}
                      >
                        <i className='ni ni-zoom-split-in' />
                      </NavLink>
                    </NavItem>

                    {/* NOTIFICATION */}
                    {/* <Notification /> */}

                    {/* QUICK LINKS */}
                    {/* <QuickLinks /> */}
                  </Nav>
                  <Nav className='align-items-center ml-auto ml-md-0' navbar>
                    {/* PROFILE */}

                    {/* <NavItem>
                    <Button onClick={this.activeBook} style={{ borderRadius: '7px', backgroundColor: colors.dodgerBlue, color: 'white', border: colors.dodgerBlue }} >
                      <i className="fas fa-plus-square"></i> <span className={`mx-2 ${styles.hidden350}`}>Kích hoạt sách</span>
                    </Button>
                  </NavItem> */}
                    {/* <NavItem className='ml-3' style={{ color: colors.dodgerBlue }}>
                      <i className="fas fa-bell fa-lg"></i>
                    </NavItem> */}

                    {/* <Profile {...this.props} userInfo={userInfo} /> */}
                  </Nav>
                </Collapse>
                <BookActivationComponent isOpen={this.state.modalVisible} toggle={this.setModalVisible} close={this.setModalVisible} />
              </Container>
            </Navbar>
          </div>
        </Affix>
      </>
    );
  }
}
AdminNavbar.defaultProps = {
  toggleSidenav: () => {},
  sidenavOpen: false,
  theme: 'dark',
};
AdminNavbar.propTypes = {
  toggleSidenav: PropTypes.func,
  sidenavOpen: PropTypes.bool,
  theme: PropTypes.oneOf(['dark', 'light']),
};

const mapStateToProps = (state) => ({
  loggedInUser: state.authReducer.loggedInUser,
});

export default connect(mapStateToProps)(AdminNavbar);
